import { createFileRoute } from '@tanstack/react-router';
import ManageTerminalsView from '../terminal/ManageTerminalsView';
export const Route = createFileRoute('/terminals/locations')({ component: ManageTerminalsView });
